import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { IGetState } from '../../../../../../../types/types';
import { getCurrentRoute } from '../../../../../../../store/router/selectors/getCurrentRoute';
import { ERoutes } from '../../../../../../../store/router/constants';
import { getActiveCardId } from '../../../../../../../store/router/selectors/getActiveCardId';
import { scrollToActiveCardIdlSet } from '../../../../../main/kanbanView/store/actions/scrollToActiveCardIdlSet';
import { hintHide } from '../../../../../hints/effects/hintHide';
import { EHintKey } from '../../../../../hints';
import { CLASS_ASIDE_PANEL_BODY } from '../../../../asidePanel/components/AsidePanelBody/constants';
import { SegmentAsidePanelEvent, segmentTrackAction } from '../../../../../../../middlewares/segment';

let isScrolled = false;

export const tabDetailsClick = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const currentRoute = getCurrentRoute(getState());
        if (currentRoute === ERoutes.EDIT_CARD) {
            const cardId = getActiveCardId(getState());
            if (cardId) {
                if (isScrolled) {
                    isScrolled = false;
                    const tab = document.querySelector('.' + CLASS_ASIDE_PANEL_BODY) as HTMLElement;
                    if (tab) {
                        tab.scroll({ behavior: 'smooth', top: 0 });
                        dispatch(segmentTrackAction(SegmentAsidePanelEvent.SCROLL_TOP_BY_TAB_CLICK));
                    }
                } else {
                    isScrolled = true;
                    function onScroll() {
                        isScrolled = false;
                        document.removeEventListener('scroll', onScroll);
                    }
                    document.addEventListener('scroll', onScroll);
                    dispatch(scrollToActiveCardIdlSet(true));
                    setTimeout(() => {
                        dispatch(scrollToActiveCardIdlSet(null));
                    }, 0);
                    dispatch(hintHide(EHintKey.CARD_SCROLL));
                }
            }
        }
    };
    return action;
};
